import React, { Component } from 'react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'rc-select/assets/index.css';

import 'moment/locale/th';
import moment, { months } from 'moment';

var currentYear=null;

class DateTimeRange extends Component {
  constructor(props) {
    super(props);

    moment.locale('th');
    //moment().utcOffset(-420)
    console.log(moment().zone());
    console.log('int', this.props.initialStartDate,this.props.initialEndDate);

    this.state = {
      focusedInput:null,
      startDate: !this.props.initialStartDate || this.props.initialStartDate === null ? moment(): this.dateWrapper(moment(this.props.initialStartDate)),
      endDate: !this.props.initialEndDate || this.props.initialEndDate === null ? moment(): this.dateWrapper(moment(this.props.initialEndDate)),
      budStartDate:null,
      budEndtDate:null
    };
    this.props.onSelectDate(this.state.startDate,this.state.endDate);
  }

  componentDidMount(){
    console.log('componentDidMount');
    if(this.state.startDate!=null)
      currentYear = this.state.startDate.clone();
    else
      currentYear = moment();
    this.setState({ monthFormat: 'MMMM '+ (currentYear.toObject().years+543) });
  }

    handleSelect(startDate,endDate){
        // this.setState({
        //   startDate: startDate && this.dateWrapper(startDate),
        //   endDate: endDate && this.dateWrapper(endDate),
        // });
        let budStartDate=null;
        let budEndDate=null;
        if(startDate!=null)
          budStartDate=moment(startDate.toObject().date+'/'+(startDate.toObject().months+1)+'/'+(startDate.toObject().years+543));
        if(endDate!=null)
          budEndDate=moment(endDate.toObject().date+'/'+(endDate.toObject().months+1)+'/'+(endDate.toObject().years+543));
        this.props.onSelectDate(startDate,endDate,budStartDate,budEndDate);
    }
    dateWrapper(rDate){
      console.log("ddddd")
      let rDateWrapper=rDate;
      if(rDate!=null && rDate.toObject().years>2500){
        rDateWrapper=moment((rDate.toObject().years-543)+'/'+rDate.toObject().months+'/'+rDate.toObject().date);
      }
      // if(rDate!=null){
      //   console.log("dateWrapper",rDate);
      //   this.setState({
      //     displayFormat: () =>'DD/MM/'+ parseInt( rDate.toObject().years+543)
      //   })
      // }
      //this.props.displayFormat='DD-MM-'+rDate.toObject().years+543;
      return rDateWrapper;
    }
    nextMonthClick(){

      //console.log(currentYear)
      this.setState({ monthFormat: 'MMMM '+ (currentYear.toObject().years+543) });
      currentYear.add(1, 'month');
    }
    prevMonthClick(){
      currentYear.add(-1, 'month');
      //console.log(currentYear)
      this.setState({ monthFormat: 'MMMM '+ (currentYear.toObject().years+543) });

    }

    render(){
        const {displayFormat,monthFormat,budStartDate,budEndDate}=this.state;
        console.log("render",displayFormat);

        return (
            <div>

                {/* <div class="DateInput__display-text DateInput__display-text--has-input DateInput__display-text--focused">{budStartDate}</div>

                <div class="DateInput__display-text DateInput__display-text--has-input DateInput__display-text--focused">{budEndDate}</div> */}

                <DateRangePicker ref={(DateRangePickerShape) => { this.dateRange = DateRangePickerShape; }}
                    startDatePlaceholderText={'เริ่มต้น'}
                    endDatePlaceholderText={'สิ้นสุด'}
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    onDatesChange={({ startDate, endDate }) => {this.setState({ startDate, endDate });this.handleSelect(startDate, endDate)}} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    numberOfMonths={1}  autoFocus  showClearDates  block readOnly
                    minimumNights={0}
                    small={this.props.small}
                    disabled ={this.props.isDisable}
                    isOutsideRange={this.props.isBack? day => {
                        let dayIsBlocked = false;
                        if (moment().diff(day) < 0) {
                          dayIsBlocked = true;
                        }
                        return dayIsBlocked;
                        }:
                        day => {
                          let dayIsBlocked = false;
                          if (moment().diff(day) >= 0) {
                            dayIsBlocked = true;
                          }
                          return dayIsBlocked;
                        }
                   }
                    //displayFormat={displayFormat}
                    //monthFormat={monthFormat}
                    // onPrevMonthClick={this.prevMonthClick.bind(this)}
                    // onNextMonthClick={this.nextMonthClick.bind(this)}


                />
            </div>
        )
    }
}

DateTimeRange.defaultProps = {
  initialStartDate:null,
  initialEndDate: null,
  isBack:false,
  small:false,
  isDisable:false
};

export default DateTimeRange;



// WEBPACK FOOTER //
// ./src/app/view/components/UserControl/DateTimeRange/DateTimeRange.js